import InfoIconModal from '@/components/infoIcon/InfoIconModal';
import classNames from 'classnames';

import classes from './ProductCardBenefitsList.module.scss';

type ProductCardBenefitsListProps = {
  benefits: {
    label?: string;
    infoTitle?: string;
    infoText?: string;
  }[];
  limit?: number;
  size?: 'small';
};

const ProductCardBenefitsList: React.FC<ProductCardBenefitsListProps> = ({ benefits, limit, size }) => {
  const benefitsList = limit ? benefits.slice(0, limit) : benefits;

  return (
    <ul
      data-testid="product-card-benefits-list"
      className={classNames(classes.benefits, { [classes.heightLimit!]: limit }, size)}
    >
      {benefitsList.map((benefit, index) => (
        <li data-testid={'product-card-benefits-item' + Number(index + 1)} key={index}>
          <div>
            <span dangerouslySetInnerHTML={{ __html: benefit.label ?? '' }} />
            {benefit.infoText && (
              <InfoIconModal
                headline={benefit.infoTitle}
                className={classNames(classes.benefitsIcon)}
                trackingLabel={benefit.label || 'Benefit'}
              >
                <div dangerouslySetInnerHTML={{ __html: benefit.infoText }} />
              </InfoIconModal>
            )}
          </div>
        </li>
      ))}
    </ul>
  );
};

export default ProductCardBenefitsList;
